import { render, staticRenderFns } from "./CampaignSegmentsTab.vue?vue&type=template&id=7bf34a7d&scoped=true"
import script from "./CampaignSegmentsTab.vue?vue&type=script&lang=js"
export * from "./CampaignSegmentsTab.vue?vue&type=script&lang=js"
import style0 from "./CampaignSegmentsTab.vue?vue&type=style&index=0&id=7bf34a7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf34a7d",
  null
  
)

export default component.exports